import { createApp } from "vue";
import BackToSearchTextPage from "./backToSearchTextPage.vue";
import SearchHistoryService from "@/services/searchHistoryService";

const backToSearchTextPageApp = document.getElementById("backToSearchTextpage");

if(backToSearchTextPageApp){
    
    SearchHistoryService.create();
    const app = createApp(BackToSearchTextPage);
    //App starten
    app.mount("#backToSearchTextpage");
}